import AccountCreated from "./accounts/created"
import CustomerContactUpdated from "./customers/contact_updated"
import CustomerEmailSent from "./customers/email_sent"
import ReservationCreated from "./reservations/created"
import ReservationRemoved from "./reservations/removed"
import ReservationUpdated from "./reservations/updated"
import VenueCreated from "./venues/created"
import VenuePlansUpdated from "./venues/plans_updated"
import VenueUpdated from "./venues/updated"
import VenueUpdatedLayout from "./venues/updated_layout"
import VenueUpdatedReservationConfiguration from "./venues/updated_reservation_configuration"
import VenueUpdatedTags from "./venues/updated_tags"
import VenueUpdatedWorkingHours from "./venues/updated_working_hours"

const ACTIVITIES = {
  "reservation.created": ReservationCreated,
  "reservation.updated": ReservationUpdated,
  "reservation.removed": ReservationRemoved,
  "venue.created": VenueCreated,
  "venue.updated": VenueUpdated,
  "venue.updated_working_hours": VenueUpdatedWorkingHours,
  "venue.updated_layout": VenueUpdatedLayout,
  "venue.plans_updated": VenuePlansUpdated,
  "venue.updated_reservation_configuration": VenueUpdatedReservationConfiguration,
  "venue.updated_tags": VenueUpdatedTags,
  "account.created": AccountCreated,
  "customer.contact_updated": CustomerContactUpdated,
  "customer.email_sent": CustomerEmailSent,
}

export default ACTIVITIES
